import { zodResolver } from '@hookform/resolvers/zod';
import { FC, PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';

const cloneableCampaign = z.union([
  z.object({ messageTypeIdEmail: z.number(), senderEmail: z.string() }),
  z.object({ messageTypeIdSMS: z.number(), senderSMS: z.number() }),
  z.object({ messageTypeId: z.number() }),
]);

const schema = z.record(z.string(), cloneableCampaign);

export type CloneFormSchemaType = Required<z.infer<typeof schema>>;

export const CloneJourneyFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const methods = useForm<CloneFormSchemaType>({
    defaultValues: {},
    mode: 'all',
    resolver: zodResolver(schema),
    shouldUnregister: true,
    // uncomment to debug formData
    // resolver: async (data, context, options) => {
    //   // console.log('formData', data);
    //   // console.log('validation result', await zodResolver(schema)(data, context, options))
    //   return zodResolver(schema)(data, context, options);
    // },
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
